module.exports = __webpack_public_path__ + "static/media/ResourcesMarkdown.ebe1a66f.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/BannerItems/Contents/ResourcesMarkdown.md
// module id = 1716
// module chunks = 0